import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./dropdown.scss";
import type { DropdownProps } from "./Dropdown.types";
import Select from "react-select";
import Icon from "../icon/Icon";

const Dropdown = React.forwardRef<any, DropdownProps>(({
  choices,
  onChangeChoice,
  label,
  inline,
  placeholder,
  searchable,
  disabled = false,
  name,
  id,  
  error,
  errorMessage,
  defaultValue,
}, ref) => {
  const [valueDisable, setValueDisable] = useState(disabled);
  const isInline = inline ? "sb-dropdown--inline" : "";
  const isDisabled = valueDisable ? "sb-dropdown--disabled" : "";
  const isError = error ? "sb-dropdown--error" : "";

  useEffect(() => {
    setValueDisable(valueDisable);
  }, [disabled]);
  return (
    <div
      id={id}
      className={["sb-dropdown", isInline, isDisabled, isError].join(" ")}
      data-testid="sb-dropdown"
    >
      {label && (
        <label className="sb-dropdown__label" data-testid="sb-dropdown__label">
          {label}
        </label>
      )}
      <Select
        name={name}
        options={choices}
        classNamePrefix="sb-dropdown"
        defaultValue={defaultValue || null}
        getOptionLabel={(opt) => opt.label}
        getOptionValue={(opt) => opt.value}
        isSearchable={searchable}
        placeholder={placeholder}
        isMulti={false}
        isDisabled={valueDisable}
        onChange={(opt: any) => {
          !!onChangeChoice && onChangeChoice(opt.value);
        }}
        ref={ref}      
      />
      <div
        className={`flex text-small-02 ${
          error ? "justify-between" : "justify-end"
        } ${error && "mt-xsm"}`}
      >
        {error && (
          <p className="flex text-error mr-sm">
            <Icon
              iconName="alert-triangle"
              size={13}
              className="text-error mr-xsm"
            />
            {errorMessage}
          </p>
        )}
      </div>
    </div>
  );
});

Dropdown.propTypes = {
  /**
   * Dropdown choices
   */
  choices: PropTypes.array.isRequired,
  /**
   * Dropdown onChangeChoice
   */
  onChangeChoice: PropTypes.func,
  /**
   * Dropdown label
   */
  label: PropTypes.string,
  /**
   * Dropdown placeholder
   */
  placeholder: PropTypes.string,
  /**
   * searchable
   */
  searchable: PropTypes.bool,
  /**
   * Disabled
   */
  disabled: PropTypes.bool,
  /**
   * inline
   */
  inline: PropTypes.bool,
  /**
   * name
   */
  name: PropTypes.string,
  /**
   * id
   */
  id: PropTypes.string,  
  /**
   * error
   */
  error: PropTypes.bool,
  /**
   * errorMessage
   */
  errorMessage: PropTypes.string,
  /**
   * defaultValue
   */
  defaultValue: PropTypes.any,
};

Dropdown.defaultProps = {
  choices: [
    { value: "122", label: "Seleccione una opción", hiddenOption: true },
    {
      value: "123",
      label:
        "Opción muy grande que aparece en el dropdown que debe ser controlado. Lorem ipsoum selet amonet os sebut",
    },
    { value: "124", label: "Opción 2" },
    { value: "125", label: "Opción 3" },
    { value: "126", label: "Opción 4", isDisabled: true },
    { value: "127", label: "Opción 5", isDisabled: true },
    { value: "128", label: "Opción 6" },
  ],
  onChangeChoice: () => {},
  label: "",
  placeholder: "",
  inline: false,
  disabled: false,
  name: "",
  id: "",
  defaultValue: undefined,  
};

export default Dropdown;
